<template>
  <div class="wrapper">
    <el-form
      ref="formData"
      :model="formData"
      :rules="rules"
      label-width="150px"
    >
      <div class="titleh1"><code />纳税人信息</div>
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item prop="taxPayerName" label="纳税人名称">
            <el-input
              v-model="formData.taxPayerName"
              clearable
              :disabled="true"
            />
          </el-form-item>
        </el-col>
        <!-- <el-col :span="6">
          <el-form-item prop="taxPayerEnglishName" label="纳税人英文名称">
            <el-input
              v-model="formData.taxPayerEnglishName"
              clearable
              maxlength="255"
            />
          </el-form-item>
        </el-col> -->
        <el-col :span="6">
          <el-form-item prop="taxPayerNo" label="纳税人识别号">
            <el-input
              v-model="formData.taxPayerNo"
              clearable
              :disabled="true"
            />
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item prop="taxPayerStatus" label="纳税人状态">
            <el-input
              v-model="formData.taxPayerStatus"
              clearable
              maxlength="10"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item prop="industryCode" label="行业">
            <el-cascader
              ref="industryCodeList"
              v-model="industryCodeList"
              placeholder="请选择行业"
              :options="industryOptions"
              :show-all-levels="false"
              clearable
              :props="{
                checkStrictly: true,
                value: 'industryCode',
                label: 'industryName',
                children: 'child'
              }"
              @change="industryChange"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item prop="taxBureau" label="主管税务局">
            <el-input v-model="formData.taxBureau" clearable maxlength="64" />
          </el-form-item>
        </el-col>
        <!-- <el-col :span="6">
          <el-form-item prop="taxOffice" label="主管税务所">
            <el-input v-model="formData.taxOffice" clearable maxlength="64" />
          </el-form-item>
        </el-col> -->
        <el-col :span="6">
          <el-form-item prop="registerCityCode" label="注册区域">
            <el-cascader
              ref="registerCityCode"
              v-model="registerCityCode"
              :options="options"
              clearable
              :props="{
                value: 'countyCode',
                label: 'countyName',
                children: 'children'
              }"
              @change="setRegisterAre"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item prop="registerAddress" label="注册地址">
            <el-input
              v-model="formData.registerAddress"
              clearable
              maxlength="300"
            />
          </el-form-item>
        </el-col>
        <!-- <el-col :span="6">
          <el-form-item prop="productCityCode" label="生产经营区域">
            <el-cascader
              ref="productCityCode"
              v-model="productCityCode"
              :options="options"
              clearable
              :props="{
                value: 'countyCode',
                label: 'countyName',
                children: 'children'
              }"
              @change="setProductArea"
            />
          </el-form-item>
        </el-col> -->
        <!-- <el-col :span="6">
          <el-form-item prop="productAddress" label="生产经营地址">
            <el-input
              v-model="formData.productAddress"
              clearable
              maxlength="255"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item prop="street" label="街道乡镇">
            <el-input v-model="formData.street" clearable maxlength="255" />
          </el-form-item>
        </el-col> -->
        <el-col :span="24">
          <el-form-item prop="businessScope" label="经营范围">
            <el-input
              v-model="formData.businessScope"
              type="textarea"
              :rows="5"
              clearable
              maxlength="1000"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <div class="titleh1"><code />法人信息</div>
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item prop="legalName" label="法人姓名">
            <el-input v-model="formData.legalName" clearable maxlength="128" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item prop="legalIdKinds" label="法人身份证件种类">
            <el-select
              v-model="formData.legalIdKinds"
              placeholder="请选择身份证件种类"
              filterable
              clearable
            >
              <el-option
                v-for="(item, k) in idKind"
                :key="k + '123'"
                :label="item.name"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="9">
          <el-form-item prop="legalIdNo" label="法人证件号码">
            <el-input v-model="formData.legalIdNo" clearable maxlength="64" />
          </el-form-item>
        </el-col>
        <!-- <el-col :span="6">
          <el-form-item prop="legalPhone" label="法人固定电话">
            <el-input v-model="formData.legalPhone" clearable maxlength="32" />
          </el-form-item>
        </el-col> -->
        <!-- <el-col :span="6">
          <el-form-item prop="legalMobile" label="法人移动电话">
            <el-input v-model="formData.legalMobile" clearable maxlength="32" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item prop="legalEmail" label="法人电子信箱">
            <el-input v-model="formData.legalEmail" clearable maxlength="32" />
          </el-form-item>
        </el-col> -->
      </el-row>
      <div class="titleh1"><code />财务负责人信息</div>
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item prop="financeName" label="财务姓名">
            <el-input v-model="formData.financeName" clearable maxlength="32" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item prop="financeIdKinds" label="财务身份证件种类">
            <el-select
              v-model="formData.financeIdKinds"
              placeholder="请选择身份证件种类"
              filterable
              clearable
            >
              <el-option
                v-for="(item, k) in idKind"
                :key="k + 'abc'"
                :label="item.name"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="9">
          <el-form-item prop="financeIdNo" label="财务证件号码">
            <el-input v-model="formData.financeIdNo" clearable maxlength="64" />
          </el-form-item>
        </el-col>
        <!-- <el-col :span="6">
          <el-form-item prop="financePhone" label="财务固定电话">
            <el-input
              v-model="formData.financePhone"
              clearable
              maxlength="32"
            />
          </el-form-item>
        </el-col> -->
        <!-- <el-col :span="6">
          <el-form-item prop="financeMobile" label="财务移动电话">
            <el-input
              v-model="formData.financeMobile"
              clearable
              maxlength="32"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item prop="financeEmail" label="财务电子信箱">
            <el-input
              v-model="formData.financeEmail"
              clearable
              maxlength="32"
            />
          </el-form-item>
        </el-col> -->
      </el-row>
      <div class="titleh1"><code />办税人信息</div>
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item prop="taxHandleName" label="办税人姓名">
            <el-input
              v-model="formData.taxHandleName"
              clearable
              maxlength="32"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item prop="taxHandleIdKinds" label="办税人身份证件种类">
            <el-select
              v-model="formData.taxHandleIdKinds"
              placeholder="请选择身份证件种类"
              filterable
              clearable
            >
              <el-option
                v-for="(item, k) in idKind"
                :key="k + 'a1b2'"
                :label="item.name"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="9">
          <el-form-item prop="taxHandleIdNo" label="办税人证件号码">
            <el-input
              v-model="formData.taxHandleIdNo"
              clearable
              maxlength="64"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item prop="taxHandleMobile" label="办税人移动电话">
            <el-input
              v-model="formData.taxHandleMobile"
              clearable
              maxlength="32"
            />
          </el-form-item>
        </el-col>
        <!-- <el-col :span="6">
          <el-form-item prop="taxHandlePhone" label="办税人固定电话">
            <el-input
              v-model="formData.taxHandlePhone"
              clearable
              maxlength="32"
            />
          </el-form-item>
        </el-col> -->
        <!-- 
        <el-col :span="6">
          <el-form-item prop="taxHandleEmail" label="办税人电子信箱">
            <el-input
              v-model="formData.taxHandleEmail"
              clearable
              maxlength="32"
            />
          </el-form-item>
        </el-col> -->
      </el-row>
      <div class="titleh1"><code />其他信息</div>
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item prop="registerCapital" label="注册资本">
            <el-input
              v-model="formData.registerCapital"
              clearable
              maxlength="32"
            />
            <div class="form-tip">单位万元，保留4位有效小数</div>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="6">
          <el-form-item prop="taxAgentName" label="税务代理人名称">
            <el-input
              v-model="formData.taxAgentName"
              clearable
              maxlength="64"
            />
          </el-form-item>
        </el-col> -->
        <el-col :span="6">
          <el-form-item prop="employNumbers" label="从业人数">
            <el-input
              v-model="formData.employNumbers"
              type="number"
              clearable
              max="9999999999"
            />
          </el-form-item>
        </el-col>
        <!-- <el-col :span="6">
          <el-form-item prop="website" label="网址">
            <el-input v-model="formData.website" clearable maxlength="64" />
          </el-form-item>
        </el-col> -->
        <el-col :span="6">
          <el-form-item prop="taxHandleBank" label="开户银行">
            <el-input
              v-model="formData.taxHandleBank"
              clearable
              maxlength="64"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item prop="taxHandleBankNo" label="银行卡号">
            <el-input
              v-model="formData.taxHandleBankNo"
              clearable
              maxlength="64"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item prop="taxHandleBankPlace" label="开户银行网点">
            <el-input
              v-model="formData.taxHandleBankPlace"
              clearable
              maxlength="255"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item prop="yyzzfj" label="营业执照图片">
            <ImgUpload
              :upload-config="{
                lebal: '营业执照图片',
                prefix: 'yyzzfj',
                form: formData,
                suffix: ''
              }"
              :disabled="true"
              :required="false"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <div v-if="switchTax == 2" class="titleh1"><code />邮寄发票信息</div>
      <el-row v-if="switchTax == 2" :gutter="20">
        <el-col :span="6">
          <el-form-item prop="invoiceRecipient" label="邮寄发票接收人姓名">
            <el-input
              v-model="formData.invoiceRecipient"
              clearable
              maxlength="255"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item prop="invoiceAddress" label="邮寄发票接收地址">
            <el-input
              v-model="formData.invoiceAddress"
              clearable
              maxlength="255"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item prop="invoicePhone" label="邮寄发票接收电话">
            <el-input
              v-model="formData.invoicePhone"
              clearable
              maxlength="32"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <div style="text-align:center">
        <el-form-item>
          <el-button
            v-if="getLimit('enterpriseInform_submit_button')"
            type="primary"
            @click="onSubmit"
            >提交</el-button
          >
        </el-form-item>
      </div>
    </el-form>
  </div>
</template>

<script>
import { industryTree } from "@/api/orderform";
import { saveOrUpdate, getinfo, taxSwitch } from "@/api/Taxation";
import { getListDict } from "@/api/shipment";
import ImgUpload from "@/components/ImgUpload";
export default {
  components: {
    ImgUpload
  },
  data() {
    // var validatorPhone = (rule, value, callback) => {
    //   validatePhone(value) ? callback() : callback(new Error("手机号格式有误"));
    // };
    // var validTelPhone = (rule, value, callback) => {
    //   validateTelephone(value)
    //     ? callback()
    //     : callback(new Error("固定电话格式有误"));
    // };
    return {
      formData: {},
      registerCityCode: [],
      productCityCode: [],
      industryCodeList: [],
      rules: {
        taxPayerName: [
          { required: true, message: "请输入纳税人名称", trigger: "blur" }
        ],
        taxPayerNo: [
          { required: true, message: "请输入纳税人识别码", trigger: "blur" }
        ],
        industryCode: [
          { required: true, message: "请选择行业", trigger: "change" }
        ],
        taxOffice: [
          { required: true, message: "请输入主管税务所", trigger: "blur" },
          { max: 64, message: "长度不超过64个字符", trigger: "blur" }
        ],
        taxPayerStatus: [
          { required: true, message: "请输入纳税人状态", trigger: "blur" },
          { max: 10, message: "长度不超过10个字符", trigger: "blur" }
        ],
        taxBureau: [
          { required: true, message: "请输入主管税务局", trigger: "blur" }
        ],
        productCityCode: [
          { required: true, message: "请选择生产经营区域", trigger: "change" }
        ],
        productAddress: [
          { required: true, message: "请输入生产经营地址", trigger: "blur" }
        ],
        registerCityCode: [
          { required: true, message: "请选择注册区域", trigger: "blur" }
        ],
        street: [
          { required: true, message: "请输入街道乡镇", trigger: "blur" }
        ],
        businessScope: [
          { required: true, message: "经营范围", trigger: "blur" }
        ],
        legalName: [
          { required: true, message: "请输入法人姓名", trigger: "blur" },
          { max: 128, message: "长度不超过128个字符", trigger: "blur" }
        ],
        legalIdKinds: [
          {
            required: true,
            message: "请输入法人身份证件种类",
            trigger: "change"
          }
        ],
        legalIdNo: [
          { required: true, message: "请输入法人证件号码", trigger: "blur" }
        ],
        // legalPhone: [
        //   { required: true, message: "请输入法人固定电话", trigger: "blur" },
        //   { validator: validTelPhone, trigger: "blur" },
        // ],
        // legalMobile: [
        //   { required: true, validator: validatorPhone, trigger: "blur" }
        // ],
        // legalEmail: [
        //   { required: true, message: "请输入法人电子信箱", trigger: "blur" }
        // ],
        financeName: [
          { required: true, message: "请输入财务负责人姓名", trigger: "blur" }
        ],
        financeIdKinds: [
          {
            required: true,
            message: "请输入财务负责人身份证件种类",
            trigger: "change"
          }
        ],
        financeIdNo: [
          {
            required: true,
            message: "请输入财务负责人证件号码",
            trigger: "blur"
          }
        ],
        // financePhone: [
        //   {
        //     required: true,
        //     message: "请输入财务负责人固定电话",
        //     trigger: "blur"
        //   },
        //   { validator: validTelPhone, trigger: "blur" }
        // ],
        // financeMobile: [
        //   { required: true, validator: validatorPhone, trigger: "blur" }
        // ],
        // financeEmail: [
        //   {
        //     required: true,
        //     message: "请输入财务负责人电子信箱",
        //     trigger: "blur"
        //   }
        // ],
        taxHandleName: [
          { required: true, message: "请输入办税人姓名", trigger: "blur" }
        ],
        taxHandleIdKinds: [
          {
            required: true,
            message: "请输入办税人身份证件种类",
            trigger: "change"
          }
        ],
        taxHandleIdNo: [
          { required: true, message: "请输入办税人证件号码", trigger: "blur" }
        ],
        // taxHandlePhone: [
        //   { required: true, message: "请输入办税人固定电话", trigger: "blur" },
        //   { validator: validTelPhone, trigger: "blur" }
        // ],
        // taxHandleMobile: [
        //   { required: true, validator: validatorPhone, trigger: "blur" }
        // ],
        // taxHandleEmail: [
        //   { required: true, message: "请输入办税人电子信箱", trigger: "blur" }
        // ],
        registerCapital: [
          { required: true, message: "请输入注册资本", trigger: "blur" },
          { max: 32, message: "长度不超过32个字符", trigger: "blur" }
        ],
        taxAgentName: [
          { required: true, message: "请输入税务代理人名称", trigger: "blur" },
          { max: 64, message: "长度不超过64个字符", trigger: "blur" }
        ],
        employNumbers: [
          { required: true, message: "请输入从业人数", trigger: "blur" },
          { max: 10, message: "长度不超过10个字符", trigger: "blur" }
        ],
        website: [{ required: true, message: "请输入网址", trigger: "blur" }],
        taxHandleBank: [
          { required: true, message: "请输入开户银行", trigger: "blur" }
        ],
        taxHandleBankNo: [
          { required: true, message: "请输入银行卡号", trigger: "blur" }
        ],
        taxHandleBankPlace: [
          { required: true, message: "请输入开户银行网点", trigger: "blur" }
        ],

        invoiceRecipient: [
          {
            required: true,
            message: "请输入邮寄发票接收人姓名",
            trigger: "blur"
          }
        ],
        invoiceAddress: [
          {
            required: true,
            message: "请输入邮寄发票接收地址",
            trigger: "blur"
          }
        ],
        invoicePhone: [
          {
            required: true,
            message: "请输入邮寄发票接收电话",
            trigger: "blur"
          }
        ]
      },
      options: this.$store.state.components.areaOptions,
      idKind: [],
      industryOptions: [],
      branchCode: this.$store.state.user.party.branchCode,
      switchTax: ""
    };
  },
  created() {
    this.taxSwitch();
    this.formData.branchCode = this.branchCode;
    // this.Seladdress();
    this.getInfo();
    // 身份种类
    getListDict({ types: "idKind" }).then(response => {
      this.idKind = response.data.filter(item => item.type === "idKind")[0][
        "dictList"
      ];
    });
    industryTree().then(res => {
      this.industryOptions = res.data;
    });
  },
  methods: {
    taxSwitch() {
      taxSwitch().then(response => {
        this.switchTax = response.data;
      });
    },
    //税务上报状态
    formatterSendStatus({ cellValue }) {
      switch (cellValue) {
        case 0:
          return "未上报";
        case 1:
          return "已上报";
        case 2:
          return "上报失败";
        default:
          break;
      }
    },
    async getInfo() {
      let response = await getinfo(this.$store.state.user.code);
      let data = response.data;
      this.formData = data;
      this.$set(
        this.formData,
        "yyzzfj",
        this.formData.yyzzfj ? this.formData.yyzzfj : ""
      );
      this.formData.yyzzfj = this.formData.yyzzfj.replace(
        /^http:\/\//i,
        "https://"
      );
      if (data.registerProvinceCode === data.registerCountyCode) {
        // 香港、澳门、台湾
        this.registerCityCode = [data.registerProvinceCode];
      } else {
        this.registerCityCode = [
          data.registerProvinceCode,
          data.registerCityCode,
          data.registerCountyCode
        ];
      }

      if (data.productProvinceCode === data.productCountyCode) {
        // 香港、澳门、台湾
        this.productCityCode = [data.productProvinceCode];
      } else {
        this.productCityCode = [
          data.productProvinceCode,
          data.productCityCode,
          data.productCountyCode
        ];
      }
      if (data.industryList) {
        this.industryCodeList = data.industryList.split(",");
      }
    },
    onSubmit() {
      this.$refs["formData"].validate(valid => {
        if (valid) {
          const rLoading = this.openLoading();
          delete this.formData.businessLicensePic;
          saveOrUpdate(this.formData).then(response => {
            rLoading.close();
            this.$message({
              message: response.msg,
              type: "success"
            });
          });
        } else {
          return false;
        }
      });
    },
    // 选择行业
    industryChange(value) {
      if (value.length) {
        this.formData.industryList = value.join(",");
      } else {
        this.formData.industryList = "";
      }
      let industry = this.$refs.industryCodeList.getCheckedNodes();
      this.formData.industryCode = industry[0]
        ? industry[0].data.industryCode
        : "";
      this.formData.industryName = industry[0]
        ? industry[0].data.industryName
        : "";
    },
    // 注册地址
    setRegisterAre(value) {
      if (value.length === 3) {
        this.formData.registerProvinceCode = value[0];
        this.formData.registerCityCode = value[1];
        this.formData.registerCountyCode = value[2];
      } else if (value.length === 1) {
        // 香港、澳门、台湾
        this.formData.registerProvinceCode = value[0];
        this.formData.registerCityCode = value[0];
        this.formData.registerCountyCode = value[0];
      } else {
        this.formData.registerProvinceCode = "";
        this.formData.registerCityCode = "";
        this.formData.registerCountyCode = "";
      }
      this.$refs.formData.validateField("registerCityCode");
    },
    // 生产地址
    setProductArea(value) {
      if (value.length === 3) {
        this.formData.productProvinceCode = value[0];
        this.formData.productCityCode = value[1];
        this.formData.productCountyCode = value[2];
      } else if (value.length === 1) {
        // 香港、澳门、台湾
        this.formData.productProvinceCode = value[0];
        this.formData.productCityCode = value[0];
        this.formData.productCountyCode = value[0];
      } else {
        this.formData.productProvinceCode = "";
        this.formData.productCityCode = "";
        this.formData.productCountyCode = "";
      }
      this.$refs.formData.validateField("productCityCode");
    }
  }
};
</script>
<style scoped lang="scss">
.titleh1 {
  line-height: 50px;
  border-bottom: 1px solid #e2e2e2;
  margin-bottom: 15px;
  code {
    width: 5px;
    height: 20px;
    background-color: #ff7f21;
    float: left;
    margin-right: 5px;
    margin-top: 13px;
  }
}
::v-deep .el-form-item__content {
  position: relative;
}
.form-tip {
  position: absolute;
  left: 0;
  top: 100%;
  color: #f56c6c;
  font-size: 12px;
  line-height: 1.5;
  white-space: nowrap;
}
</style>
